function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useMemo, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { extractPureTextFromRichText, Typography } from 'seagull';
import ExtraClause from "../../../../components/AgreementStudio/ExtraClause";
import EditableTableCell from "../EditableTableCell/EditableTableCell";
import { jsx as _jsx } from "react/jsx-runtime";
function AgreementNoteContent(_ref) {
  let {
    draft,
    setDraft
  } = _ref;
  const form = useForm({
    defaultValues: {
      extraClause: draft.extraClause() || ''
    }
  });
  const [showAgreementSettingsWarning, setShowAgreementSettingsWarning] = useState(false);
  return /*#__PURE__*/_jsx(FormProvider, _objectSpread(_objectSpread({}, form), {}, {
    children: /*#__PURE__*/_jsx(ExtraClause, {
      showAgreementSettingsWarning: showAgreementSettingsWarning,
      onValidation: isValid => {
        if (isValid) return;
        setShowAgreementSettingsWarning(true);
      },
      hideLabel: true,
      onChange: v => {
        setDraft(draft.setExtraClause(JSON.stringify(v)));
      }
    })
  }));
}
export default function AgreementNoteCell(_ref2) {
  let {
    draft,
    index,
    onOpenModal,
    isDisabled,
    disabledTooltip
  } = _ref2;
  const onClick = () => onOpenModal({
    renderContent: _ref3 => {
      let {
        draft,
        setDraft
      } = _ref3;
      return {
        title: 'Agreement note',
        testid: 'edit-agreement-note-modal',
        onSubmit: defaultBehavior => {
          defaultBehavior();
        },
        content: /*#__PURE__*/_jsx(AgreementNoteContent, {
          draft: draft,
          setDraft: setDraft
        })
      };
    }
  });
  const extraClause = draft.extraClause();
  const pureText = useMemo(() => extractPureTextFromRichText(extraClause).trim(), [extraClause]);
  return /*#__PURE__*/_jsx(EditableTableCell, {
    testid: "edit-agreement-note-".concat(index),
    onClick: onClick,
    isDisabled: isDisabled,
    disabledTooltip: disabledTooltip,
    children: /*#__PURE__*/_jsx(Typography, {
      ellipsis: true,
      "data-testid": "agreement-note-".concat(index),
      skin: pureText ? 'standard' : 'secondary',
      children: pureText || 'Not set'
    })
  });
}